/*
  src/redux/entities/audience.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'audience', action].join('/');
}

export const STATE_LIST_REQUESTED = createConstant('STATE_LIST_REQUESTED');
export const STATE_LIST_LOADED = createConstant('STATE_LIST_LOADED');
export const STATE_LIST_FAILED_TO_LOAD = createConstant('STATE_LIST_FAILED_TO_LOAD');
export const GEOFILTER_LIST_REQUESTED = createConstant('GEOFILTER_LIST_REQUESTED');
export const GEOFILTER_LIST_LOADED = createConstant('GEOFILTER_LIST_LOADED');
export const GEOFILTER_LIST_FAILED_TO_LOAD = createConstant('GEOFILTER_LIST_FAILED_TO_LOAD');
export const RESPONSE_CONSTRAINT_LIST_REQUESTED = createConstant('RESPONSE_CONSTRAINT_LIST_REQUESTED');
export const RESPONSE_CONSTRAINT_LIST_LOADED = createConstant('RESPONSE_CONSTRAINT_LIST_LOADED');
export const RESPONSE_CONSTRAINT_LIST_FAILED_TO_LOAD = createConstant('RESPONSE_CONSTRAINT_LIST_FAILED_TO_LOAD');
export const NO_OP = createConstant('NO_OP');




// WEBPACK FOOTER //
// ./src/shared/redux/audience/constants.js